import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

import { Context, PreparedTollRoad } from './types/context';
import { RoutesError } from './types/routesError';

import useRoutesPoints from './hooks/useRoutesPoints';
import useRoutes from './hooks/useRoutes';
import useActiveRoutes from './hooks/useActiveRoutes';
import useRoutesStations from './hooks/useRoutesStations';

export const RoutesContext = createContext({} as Context);
export const useRoutesContext = () => useContext(RoutesContext);

const RoutesProvider = ({ children }: PropsWithChildren) => {
  const [routesError, setRoutesError] = useState<RoutesError>();
  const { routes, setRoutes, onChangeRoutes, getRouteById, resetRoutes } =
    useRoutes(setRoutesError);
  const { activeRoute, setActiveRoute, resetActiveRoute } = useActiveRoutes();
  const { routesPoints, setRoutesPoints, resetRoutesPoints } =
    useRoutesPoints();
  const { routesStations, setRoutesStations, getRouteStationsById } =
    useRoutesStations();
  const [tollRoads, setTollRoads] = useState<PreparedTollRoad[]>([]);
  const [triggeredRecalculate, setTriggeredRecalculate] = useState(false);

  const value = useMemo(
    () => ({
      routesError,
      setRoutesError,

      routes,
      setRoutes,
      onChangeRoutes,
      getRouteById,
      resetRoutes,

      activeRoute,
      setActiveRoute,
      resetActiveRoute,

      routesPoints,
      setRoutesPoints,
      resetRoutesPoints,

      routesStations,
      setRoutesStations,
      getRouteStationsById,

      tollRoads,
      setTollRoads,
      triggeredRecalculate,
      setTriggeredRecalculate,
    }),
    [
      routesError,
      setRoutesError,

      routes,
      setRoutes,
      onChangeRoutes,
      getRouteById,
      resetRoutes,

      activeRoute,
      setActiveRoute,
      resetActiveRoute,

      routesPoints,
      setRoutesPoints,
      resetRoutesPoints,

      routesStations,
      setRoutesStations,
      getRouteStationsById,

      tollRoads,
      setTollRoads,
      triggeredRecalculate,
      setTriggeredRecalculate,
    ],
  );

  return (
    <RoutesContext.Provider value={value}>{children}</RoutesContext.Provider>
  );
};

export default RoutesProvider;
